import React, { useEffect } from "react";
import { useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";

const SignOut = () => {
  const navigate = useNavigate();
  const signOut = useSignOut();

  useEffect(() => {
    signOut();
    try {
      localStorage.removeItem("_auth");
      localStorage.removeItem("_auth_state");
      localStorage.removeItem("_auth_storage");
      localStorage.removeItem("_auth_type");
      localStorage.removeItem("sparkaichatbot_auth");
      localStorage.removeItem("sparkaichatbot_auth_state");
      localStorage.removeItem("sparkaichatbot_auth_type");
      localStorage.removeItem("sparkaichatbot_auth_storage");
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("sparkaichatbot") || key.startsWith("_auth")) {
          localStorage.removeItem(key);
        }
      });
    } catch {
      // Storage may be unavailable; the sign-out above already cleared the session.
    }
    navigate("/login");
  }, []);

  return <></>;
};

export default SignOut;
